<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>{{ Number(event_type_id) === 3 ? 'Alerts' : 'Announcements' }}</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h5>Add {{ Number(event_type_id) === 3 ? 'Alert' : 'Announcement' }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <AddEventForm :event="event" :from_template="template_id !== undefined" :callback="template_id ? createFromTemplate : createSoundStep" />
      </div>
      <div class="col-4">
        <CurrentExtensions :default_type="Number(event_type_id) === 3 ? 'alert' : 'announcement'"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '../../router'
import CurrentExtensions from '../../components/CurrentExtensions'
import AddEventForm from '../../components/Event/AddEventForm.vue'

export default {
  props: {
    event_type_id: [Number, String],
    template_id: [Number]
  },
  data() {
    return {
      event: {
        event_id: 0,
        event_type_id: Number(this.event_type_id),
        event_action_type_id: 3,
        name: '',
        description: '',
        extension: '9',
        input_number: 1,
        device_id: null,
        enabled: 1,
        chat_enabled: false
      }
    }
  },
  components: { CurrentExtensions, AddEventForm },
  computed: {
    ...mapGetters({
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      template_event: 'singleEvent',
      template_event_steps: 'allEventSteps',
      advanced_visuals: 'allAdvancedVisuals'
    }),
    template_advanced_visuals() {
      if(this.template_event.event_id) {
        return this.advanced_visuals.filter(visual => visual.event_id === this.template_event.event_id)
      }
    }
  },
  watch: {
    template_id: {
      handler(new_template_id) {
        if(new_template_id) {
          this.$store.dispatch('getEvent', new_template_id)
            .then(template_event => {
              this.event = { ...template_event }
              this.event.name += ' (copy)'
              this.event.extension = '9'
              this.event.event_id = 0
              this.$store.dispatch('getEventSteps', template_event.event_id)
              this.$store.dispatch('getAdvancedVisuals')
            })
        }
      },
      immediate: true
    }
  },
  methods: {
    createSoundStep(event_id, zone_id, sound_type_id, sound) {
      const step = {
          event_step_id: 0,
          event_id: event_id,
          event_step_order_type_id: 1,
          event_step_command_type_id: 1,
          zone_id: zone_id,
          sound_type_id: sound_type_id,
          sound_id: sound.value,
          sound: sound,
          advanced_visual_id: 0,
          barix_command: '',
          message: '',
          display_text: '',
          flasher_type: 'simultaneously',
          event_step_phone_numbers: [],
          sleep_duration: 0,
          to_event_step_id: 0,
          order: 0
      }
      this.$store.dispatch('addEditEventStep', { event_step: step, next: 'EventSummary' })
    },
    createFromTemplate(event_id) {
      if(this.template_id) {
        const template_advanced_visuals = this.template_advanced_visuals
        const template_event_steps = this.template_event_steps

        const visualIdMapping = {}

        const visualPromises = []
        const stepPromises = []
        //Create visuals first, then event steps
        if(template_advanced_visuals.length > 0) {
          for(let visual of template_advanced_visuals) {
            const template_visual_id = visual.advanced_visual_id
            visualPromises.push(
              this.$store.dispatch('addEditAdvancedVisual', { advanced_visual: {
                ...visual,
                advanced_visual_id: 0,
                event_id: event_id
              }})
              .then(saved_visual => {
                visualIdMapping[template_visual_id] = saved_visual.advanced_visual_id
                return Promise.resolve()
              })
            )
          }

          Promise.all(visualPromises)
            .then(() => {
              for(let step of template_event_steps) {
                stepPromises.push(this.$store.dispatch('addEditEventStep', { event_step: {
                  ...step,
                  event_step_id: 0,
                  event_id: event_id,
                  advanced_visual_id: visualIdMapping[step.advanced_visual_id] || null,
                  from_template: true
                }}))
              }
            })
            
        }
        // Only create event steps, no visuals
        else {
          for(let step of template_event_steps) {
            stepPromises.push(this.$store.dispatch('addEditEventStep', { event_step: {
              ...step,
              event_step_id: 0,
              event_id: event_id,
              from_template: true
            }}))
          }
        }

        Promise.all(stepPromises)
          .then(() => router.push({ name: 'EventSummary', params: { event_id }}))
      }
    }
  },
  created() {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX')
  }
}
</script>

<style scoped></style>
